import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { useTranslation } from "../../contexts/TranslationContext";

import "./main.scss";

import { AuthProvider } from "../../contexts/AuthContext";
import { InactivityProvider } from "../../contexts/InactivityContext";
import { GlobalPopupProvider } from "../../contexts/GlobalPopupContext";

const RootLayout = () => {
    const { language } = useTranslation();
    
    return (
        <>
            <AuthProvider>
                <InactivityProvider>
                    <GlobalPopupProvider>
                        <Navbar />
                        <div className="main">
                            <React.Suspense fallback={
                                <div className="app-loading">
                                    <div className="loading-container">
                                        <div className="loading-spinner"></div>
                                        <p>{language?.loading || "Loading page..."}</p>
                                    </div>
                                </div>
                            }>
                                <Outlet />
                            </React.Suspense>
                        </div>
                        <Footer />
                    </GlobalPopupProvider>
                </InactivityProvider>
            </AuthProvider>
        </>
    );
};

export default RootLayout;